
module.exports = {
  server_url: "https://www.xirit.co",
  home_url: "",
  buyed_url: "bought",
  error_url: "error",
  prefix: "",
  init: function() {}
}



// WEBPACK FOOTER //
// ./lib/config/prod-client.js